import React, { useEffect,useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Col, Input, Form, Select, Row } from 'antd';
import { actions } from './WorkOrderReference.redux';
import _ from 'lodash';



const AddComponentForm = () => {
	const dispatch      = useDispatch(),
		  [ form ]      = Form.useForm(),
		  stagesList    = useSelector(state => state.workOrderReference.stagesList),
		  savingChanges = useSelector(state => state.workOrderReference.savingComponents),
          itemsList     = useSelector(state => state.workOrderReference.itemsList);

	const [plannedQty, setPlannedQty] = useState('');
    const [baseQty, setBaseQty] = useState('');

    const handlePlannedQtyChange = (e) => {
		setPlannedQty(e.target.value);
		setBaseQty('');
	};

    const handleBaseQtyChange = (e) => {
        setBaseQty(e.target.value);
        setPlannedQty('');
        };

	const newComponent = {
		'StageId': '',
		'Stage': '',
		'ItemCode': '',
		'ItemName': '',
		'BaseQty': '',
		'PlannedQty': '',
		'ReferenceDesignator': '',
		'LineNotes': '',
		'IsNewRow': true,
	};

	useEffect(() => {
		// good idea to run the clean up method on forms to clear out any unsaved changes
		return () => {
			form.resetFields();
		}
	}, []);

	const submitNewComponents = (values) => {
		if (form.validateFields()) {
			console.log(values);
			dispatch(actions.addNewComponentRow(values));
		}
	};

	const closeAddComponentForm = () => {
		dispatch(actions.setState({ addingComponents: false }));
		form.resetFields();
	};


    return (
		<div
			className="ts_requestform"
		>
			<Row
				gutter={{
					xs: 8,
					sm: 16,
					md: 24,
					lg: 32,
				}}
			>
				<Col
					flex="auto"
				>
					<Form
						className="ts_form_margin"
						layout="horizontal"
						form={form}
						initialValues={newComponent}
						requiredMark={true}
						onFinish={submitNewComponents}
						size="medium"
					>
						<Row
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
							}}
						>
							<Col flex="auto">
								<Form.Item
									className="ts_portal_form_item"
									label="Item Code"
									name="ItemCode"
									disabled={savingChanges}
									required
									rules={[ 
										{ required: true, message: 'Item code is required' }
									]}
								>
									<Select
										showSearch
										optionFilterProp="children"
										filterOption={(input, option) =>  option.children.toLowerCase().includes(input.toLowerCase())}
										onChange={(value) => {
											const item = _.find(itemsList, (item) => item.ItemCode === value);
											if (item && item.ItemName) {
												form.setFieldValue('ItemName', item.ItemName);
											}
										}}
									>
										<Select.Option key="select_item" value="" selected>Select Item #</Select.Option>
											{
												itemsList.map((item, index) => {
													return (
														<Select.Option key={index} value={item.ItemCode}>{item.DisplayName}</Select.Option>
													)
												})
											}
										</Select>
								</Form.Item>
							
							</Col>	

							<Form.Item
								hidden={true}
								name="ItemName"
							>
								<Input />
							</Form.Item>

							<Form.Item
								hidden={true}
								name="Stage"
							>
								<Input />
							</Form.Item>
						
						</Row>

						<Row
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
							}}
						>
							<Col flex={2}>
								<Form.Item
									className='ts_portal_form_item'
									disabled={!!plannedQty}
									label="Quantity Per Unit"
									name="BaseQty"
									value={baseQty}
									onChange={handleBaseQtyChange}
									rules={[
										({ getFieldValue }) => ({
											validator(_, value) {
											if (!value && !getFieldValue('PlannedQty')) {
												return Promise.reject(new Error('You must enter either Total Quantity or Quantity per unit.'));
												}
											if (value && isNaN(parseInt(value))) {
												return Promise.reject(new Error('Quantity Value must be a number.'));
												}
											if (value && getFieldValue('PlannedQty')) {
												return Promise.reject(new Error('Enter only one of either Total Quantity or Quantity per unit.'));
												}
											if (value && parseInt(value) <= 0) {
												return Promise.reject(new Error('Quantity value should be greater than zero.'));
												}
										return Promise.resolve();
										},
									}),
									]}
								>
									<Input />
								</Form.Item>
									
							</Col>

							<Col flex={2}>
									<Form.Item
									className='ts_portal_form_item'
									disabled={!!baseQty}
									label="Total Quantity"
									name="PlannedQty"
									value={plannedQty}
									onChange={handlePlannedQtyChange}
									rules={[
										({ getFieldValue }) => ({
											validator(_, value) {
											if (!value && !getFieldValue('BaseQty')) {
												return Promise.reject(new Error('You must enter either Total Quantity or Quantity per unit.'));
												}
											if (value && isNaN(parseInt(value))) {
												return Promise.reject(new Error('Quantity Value must be a number.'));
											}
											if (value && getFieldValue('BaseQty')) {
												return Promise.reject(new Error('Enter only one of either Total Quantity or Quantity per unit.'));
											}
											if (value && parseInt(value) <= 0) {
												return Promise.reject(new Error('Quantity value should be greater than zero.'));
											}
										return Promise.resolve();
										},
									}),
									]}
								>
									<Input />
								</Form.Item>
							</Col>
						</Row>
						<Row
							gutter={{
							xs: 8,
							sm: 16,
							md: 24,
							lg: 32,
						}}>
							<Col flex={2}>
								<Form.Item
									className='ts_portal_form_item'
									disabled={savingChanges}
									label="Associated Route Stage"
									name="StageId"
									required
									rules={[ { required: true, message: 'You must select a stage' } ]}
								>
									<Select
										onChange={(value, option) => {
											form.setFieldValue('Stage', option.children);
										}}
									>
										<Select.Option value="">Select a route stage</Select.Option>
										{
											stagesList.map((stage, index) => {
												return <Select.Option key={index} value={stage.StageID}>{stage.OpNum}-{stage.RouteName}-{stage.Description}</Select.Option>
											})
										}
									</Select>
								</Form.Item>
							</Col>
						</Row>

						<Row
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
							}}
						>
							
							<Col flex={2}>
								<Form.Item
									className='ts_portal_form_item'
									disabled={savingChanges}
									label="Reference Designator"
									name="ReferenceDesignator"
								>
									<Input />
								</Form.Item>
							</Col>


							<Col flex={4}>
								<Form.Item
									className='ts_portal_form_item'
									disabled={savingChanges}
									label="Request Notes"
									name="LineNotes"
								>
									<Input />
								</Form.Item>
							</Col>

						</Row>
						
						<Row
							gutter={{
								xs: 8,
								sm: 16,
								md: 24,
								lg: 32,
							}}
						>
							<Col flex={3}>
								<Form.Item className="ts_portal_form_item">
									<Button
										className="ts_portal_button add_button_variant"
										size="large"
										type="default"
										block
										htmlType="submit"
									>
										Add Item to Queue
									</Button>
								</Form.Item>
							</Col>

							<Col flex={3}>
								<Form.Item className="ts_portal_form_item">
									<Button
										className="ts_portal_button"
										size="large"
										danger
										onClick={() => {
											closeAddComponentForm()
										}}
									>
										Cancel/Close Form
									</Button>
								</Form.Item>
							</Col>


						</Row>
					</Form>
				</Col>
			</Row>

		</div>
                
    );
};


export default AddComponentForm;
